import React, { useState } from "react";
import "./ShowcaseTabs.css";

const tabs = [
  {
    label: "Hospitality",
    image:
      "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=600&q=80",
    text: "Experience world-class hospitality with jobhub manpower solution. Our partners deliver comfort, care, and memorable stays for every guest.",
    stats: [
      "Trusted by 200+ hotels & resorts",
      "Awarded Best Hospitality Partner 2024",
      "Serving 10,000+ guests monthly",
    ],
  },
  {
    label: "Event Activities",
    image:
      "https://images.unsplash.com/photo-1515165562835-cf7747d3f7b1?auto=format&fit=crop&w=600&q=80",
    text: "From concerts to conferences, jobhub manpower solution brings your events to life with expert planning and vibrant execution.",
    stats: [
      "500+ events managed yearly",
      "Trusted by 100+ event companies",
      "Rated 4.9/5 by clients",
    ],
  },
  {
    label: "Corporates",
    image:
      "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&w=600&q=80",
    text: "Empowering corporates with flexible staffing, seamless operations, and innovative solutions. jobhub manpower solution is your business partner.",
    stats: [
      "19+ corporate partners",
      "Trusted by Fortune 500 companies",
      "1000+ projects delivered",
    ],
  },
  {
    label: "Other Allied Freelancing Industry",
    image:
      "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=crop&w=600&q=80",
    text: "Discover a world of freelance opportunities. jobhub manpower solution connects you to skilled professionals for every unique need.",
    stats: [
      "10,000+ freelancers registered",
      "Trusted by 200+ businesses",
      "Top-rated platform for gig work",
    ],
  },
];

const ShowcaseTabs = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="showcase-tabs-wrapper">
      {/* <h2 className="showcase-title">jobhub manpower solution</h2> */}
      <div className="showcase-tabs">
        {tabs.map((tab, idx) => (
          <button
            key={tab.label}
            className={`showcase-tab-btn${activeTab === idx ? " active" : ""}`}
            onClick={() => setActiveTab(idx)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="showcase-content-card">
        <img
          src={tabs[activeTab].image}
          alt={tabs[activeTab].label}
          className="showcase-image"
        />
        <h3 className="showcase-header">{tabs[activeTab].label}</h3>
        <p className="showcase-text">{tabs[activeTab].text}</p>
        <ul className="showcase-stats-list">
          {tabs[activeTab].stats &&
            tabs[activeTab].stats.map((stat, idx) => (
              <li key={idx} className="showcase-stat-item">
                {stat}
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};

export default ShowcaseTabs;
